import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Items from "@/pages/Items";
import BulkItemsFromPhoto from "@/pages/BulkItemsFromPhoto";
import WhatsAppInbox from "@/pages/WhatsAppInbox";
import NewBill from "@/pages/NewBill";
import { BillList, BillView } from "@/pages/Bills";
import PhotoToBill from "@/pages/PhotoToBill";
import { Customers, Suppliers } from "@/pages/CustSup";
import { Purchases } from "@/pages/Purchases";
import { Reports, Settings } from "@/pages/Reports";
import Templates from "@/pages/Templates";
import CashDrawer from "@/pages/CashDrawer";
import { ReturnList, ReturnView } from "@/pages/Returns";

function Protected({ children }) {
  const { user, loading } = useApp();
  if (loading) return <div className="min-h-screen grid place-items-center text-stone-500">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="bottom-center" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/items" element={<Protected><Items /></Protected>} />
          <Route path="/items/bulk-photo" element={<Protected><BulkItemsFromPhoto /></Protected>} />
          <Route path="/whatsapp-inbox" element={<Protected><WhatsAppInbox /></Protected>} />
          <Route path="/bills" element={<Protected><BillList /></Protected>} />
          <Route path="/bills/new" element={<Protected><NewBill /></Protected>} />
          <Route path="/bills/:id" element={<Protected><BillView /></Protected>} />
          <Route path="/returns" element={<Protected><ReturnList /></Protected>} />
          <Route path="/returns/:id" element={<Protected><ReturnView /></Protected>} />
          <Route path="/photo-to-bill" element={<Protected><PhotoToBill /></Protected>} />
          <Route path="/templates" element={<Protected><Templates /></Protected>} />
          <Route path="/customers" element={<Protected><Customers /></Protected>} />
          <Route path="/suppliers" element={<Protected><Suppliers /></Protected>} />
          <Route path="/purchases" element={<Protected><Purchases /></Protected>} />
          <Route path="/cash-drawer" element={<Protected><CashDrawer /></Protected>} />
          <Route path="/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
